{
  "version": 1,
  "asset_id": "9f29442e-495d-41c7-9dea-9dbe6bae3167",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/9f29442e-495d-41c7-9dea-9dbe6bae3167/cp14.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/9f29442e-495d-41c7-9dea-9dbe6bae3167/cp14.jpg",
  "original_filename": "cp14.jpg",
  "size": 129538,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:38:20Z"
}
